import type { MetricRecordData } from "@/types/metrics/contracts"

export function normalizeMetricRecordData(response: unknown): MetricRecordData {
  const dataShape =
    typeof response === "object" && response !== null
      ? (response as Partial<MetricRecordData> & {
          organization_id?: string | null
        })
      : {}
  const data: MetricRecordData = {
    attribution: dataShape.attribution,
    id: dataShape.id,
    metric_name: dataShape.metric_name ?? "",
    metric_display_name: dataShape.metric_display_name ?? "",
    metric_metadata: dataShape.metric_metadata ?? {},
    description: dataShape.description ?? "",
    organization_id: dataShape.organization_id ?? undefined,
    metric_manager: dataShape.metric_manager ?? "",
    locked:
      dataShape.organization_id === null || dataShape.organization_id === "",
    category: dataShape.category,
    created_at: dataShape.created_at,
    created_by: dataShape.created_by,
    last_updated_at: dataShape.last_updated_at,
    last_updated_by: dataShape.last_updated_by,
    output_type: dataShape.output_type,
    organization_threshold: dataShape.organization_threshold ?? null,
    tags: dataShape.tags ?? [],
    current_version_id: dataShape.current_version_id ?? null,
    current_version_number: dataShape.current_version_number ?? null,
    dependency_metric_ids: dataShape.dependency_metric_ids ?? null,
  }
  return data
}

export function buildMetricRecordDataById(
  records: Record<string, unknown> | undefined,
): Record<string, MetricRecordData> {
  const byId: Record<string, MetricRecordData> = {}
  for (const record of Object.values(records ?? {})) {
    if (!record) {
      continue
    }
    const data = normalizeMetricRecordData(record)
    if (data.id) {
      byId[data.id] = data
    }
  }
  return byId
}
